const BLOCK_SELECTOR = '.b-lotto-winning-numbers-slider';
const SLIDER_SELECTOR = '.b-lotto-winning-numbers-slider__cards';
const NAV_SELECTOR = '.b-lotto-winning-numbers-slider__nav';
const DATE_LABEL_SELECTOR = '.c-lotto-game-card__drawing-date, .c-lotto-game-card__est-jackpot-date';

/**
 * Format UTC datetime into the user's local calendar date.
 *
 * @param {string} utcDateTime UTC datetime from ETL.
 * @return {string}
 */
const formatBrowserLocalDate = ( utcDateTime ) => {

	if ( ! utcDateTime ) {

		return '';

	}

	const parsedDate = new Date( utcDateTime );

	if ( Number.isNaN( parsedDate.getTime() ) ) {

		return '';

	}

	return new Intl.DateTimeFormat( 'en-US', {
		month: '2-digit',
		day: '2-digit',
		year: '2-digit',
	} ).format( parsedDate );

};

/**
 * Replace server fallback date labels with browser-local dates.
 *
 * @param {HTMLElement} block The block root element.
 */
const localizeDates = ( block ) => {

	block.querySelectorAll( DATE_LABEL_SELECTOR ).forEach( ( element ) => {

		const utcDateTime = element.dataset.dateUtc || '';
		const labelPrefix = element.dataset.dateLabelPrefix || '';
		const localizedDate = formatBrowserLocalDate( utcDateTime );

		if ( ! localizedDate ) {

			return;

		}

		element.textContent = labelPrefix ? `${ labelPrefix } ${ localizedDate }` : localizedDate;

	} );

};

/**
 * Initialize a single slider instance.
 *
 * @param {HTMLElement} block The block root element.
 */
const initSlider = ( block ) => {

	localizeDates( block );

	const slider = block.querySelector( SLIDER_SELECTOR );

	if ( ! slider || slider.dataset.swiperReady === 'true' ) {

		return;

	}

	const prevEl = block.querySelector( '.b-lotto-winning-numbers-slider__nav-button--prev' );
	const nextEl = block.querySelector( '.b-lotto-winning-numbers-slider__nav-button--next' );
	const navEl = block.querySelector( NAV_SELECTOR );
	const totalSlides = slider.querySelectorAll( '.swiper-slide' ).length;

	if ( navEl ) {

		navEl.hidden = totalSlides <= 1;

	}

	const swiper = new window.Swiper( slider, {
		// Mobile: show a peek of the next card on the right edge.
		slidesPerView: 1.1,
		spaceBetween: 16,
		watchOverflow: true,
		allowTouchMove: true,
		simulateTouch: true,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
			releaseOnEdges: true,
		},
		grabCursor: true,
		threshold: 8,
		a11y: {
			enabled: true,
			prevSlideMessage: 'Previous games',
			nextSlideMessage: 'Next games',
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		navigation: ( prevEl && nextEl ) ? { prevEl, nextEl } : false,
		breakpoints: {
			576: {
				slidesPerView: 1.2,
			},
			650: {
				slidesPerView: 1.7,
			},
			768: {
				slidesPerView: 2.2,
				spaceBetween: 24,
			},
			992: {
				slidesPerView: 2.7,
				spaceBetween: 24,
			},
			1200: {
				slidesPerView: 3.2,
				spaceBetween: 24,
			},
			// 4 full cards + a peek of the 5th.
			1550: {
				slidesPerView: 4.2,
				spaceBetween: 24,
			},
		},
	} );

	if ( navEl ) {

		/**
		 * Toggle arrows visibility when slider can/cannot scroll.
		 *
		 * @return {void}
		 */
		const updateNavVisibility = () => {

			navEl.hidden = swiper.isLocked;

		};

		updateNavVisibility();
		swiper.on( 'lock', updateNavVisibility );
		swiper.on( 'unlock', updateNavVisibility );
		swiper.on( 'breakpoint', updateNavVisibility );

	}

	slider.dataset.swiperReady = 'true';

};

/**
 * Boot all sliders on the page.
 */
const init = () => {

	if ( typeof window.Swiper !== 'function' ) {

		return;

	}

	document.querySelectorAll( BLOCK_SELECTOR ).forEach( initSlider );

};

if ( document.readyState === 'loading' ) {

	document.addEventListener( 'DOMContentLoaded', init );

} else {

	init();

}

